import { ChangeDetectionStrategy, Component, input, InputSignal, signal, WritableSignal } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiDropdown } from '@taiga-ui/core'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { PostTradingEventInterface } from '@modules/options-module/post-trading/interfaces/post-trading-event.interface'
import { PostTradingEventInfoComponent } from '@shared/components/trading/orders/orders-options/tables/post-trading/actions/post-trading-event-info/post-trading-event-info.component'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-post-trading-exercises-events-actions',
	templateUrl: './post-trading-exercises-events-actions.component.html',
	styleUrl: './post-trading-exercises-events-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, TuiDropdown, PostTradingEventInfoComponent, ClickOutsideDirective, ButtonComponent],
})
export class PostTradingExercisesEventsActionsComponent {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum

	public event: InputSignal<PostTradingEventInterface | null> = input<PostTradingEventInterface | null>(null)

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)

	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this.openedDropdown.set(null)
	}
}
